export default __webpack_public_path__ + "static/media/icon-games.ba403c74.png";